/**
 * Sync open conversation list/refs when a workspace entity is renamed.
 * Matches by conversationable_type/type and conversationable_id/type_id.
 *
 * @param {Array} handlers Conversation handler instances (or plain objects in tests)
 * @param {{ id: number|string, name?: string }} entity Updated entity payload
 * @param {string} conversationable_type e.g. item, board, workspace, item-group
 */
export function applyConversationEntityUpdate(
    handlers,
    entity,
    conversationable_type,
) {
    if (
        !Array.isArray(handlers) ||
        entity?.id == null ||
        !conversationable_type ||
        entity.name == null
    ) {
        return;
    }

    const entity_id = entity.id;
    const name = entity.name;

    for (const conv of handlers) {
        if (!conv) {
            continue;
        }

        const conv_type =
            conv.originalData?.conversationable_type ??
            conv.originalData?.type ??
            conv.type;
        const conv_id =
            conv.originalData?.conversationable_id ??
            conv.originalData?.type_id ??
            conv.resourceId ??
            conv.type_id;

        if (conv_type === conversationable_type && conv_id == entity_id) {
            conv.name = name;
            if (conv.originalData && typeof conv.originalData === "object") {
                conv.originalData.name = name;
                if (
                    conversationable_type === "item" &&
                    conv.originalData.item?.id == entity_id
                ) {
                    conv.originalData.item.name = name;
                }
            }
        }

        if (conversationable_type === "board") {
            if (
                conv.board_id == entity_id ||
                (conv.type === "board" && conv.type_id == entity_id)
            ) {
                conv.board_name = name;
            }
        }

        if (conversationable_type === "workspace") {
            if (
                conv.space_id == entity_id ||
                (conv.type === "workspace" && conv.type_id == entity_id)
            ) {
                conv.space_name = name;
            }
        }
    }
}
